<template>
  <component :is="type" :src="src" :aria-label="ariaLabel" class="svg-logo">
    <img :src="src" :alt="alt" />
  </component>
</template>

<script>
/**
 * Sezione dedicata alla gestione del logo di DeaScuola.
 */
export default {
  name: "Logos",

  props: {
    /**
     * The name of the icon to display.
     */
    src: {
      type: String,
      required: true,
      default: "dea/dea_horizontal.svg",
    },
    /**
     * Descriptive text to be read to screenreaders.
     */
    ariaLabel: {
      type: String,
      default: "icon",
    },
    /**
     * Descriptive text to be read to screenreaders.
     */
    alt: {
      type: String,
      default: "",
    },
    /**
     * The html element name used for the icon.
     */
    type: {
      type: String,
      default: "picture",
    },
  },
};
</script>
